<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Pliki</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/file/list">Pliki</router-link>
        </li>
        <li class="active">
          <strong>Nowy</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis pliku [pl]</h5>
            <span class="ibox-toggle" @click="isPlOpen = !isPlOpen">
              <i :class="chevronPlClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isPlOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="fileObj.name_pl"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_pl" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_pl[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis pliku [en]</h5>
            <span class="ibox-toggle" @click="isEnOpen = !isEnOpen">
              <i :class="chevronEnClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isEnOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="fileObj.name_en"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Tytuł"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_en" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_en[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis pliku [de]</h5>
            <span class="ibox-toggle" @click="isDeOpen = !isDeOpen">
              <i :class="chevronDeClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isDeOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="fileObj.name_de"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name_de" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name_de[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis pliku [de_de]</h5>
            <span class="ibox-toggle" @click="isDeDeOpen = !isDeDeOpen">
              <i :class="chevronDeDeClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isDeDeOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="fileObj.name_cpde"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.name_cpde"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.name_cpde[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis pliku [de_en]</h5>
            <span class="ibox-toggle" @click="isDeEnOpen = !isDeEnOpen">
              <i :class="chevronDeEnClass"></i>
            </span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isDeEnOpen">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="fileObj.name_cpen"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Tytuł"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.name_cpen"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.name_cpen[0] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Konfiguracja pliku</h5>
            <span class="ibox-toggle" @click="isConfigOpen = !isConfigOpen">
              <i :class="chevronConfigClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isConfigOpen">
            <div class="form-group">
              <label class="control-label col-sm-2">Plik</label>
              <div class="col-sm-10">
                <div class="fileinput fileinput-new input-group">
                  <div class="form-control">
                    <input
                      type="file"
                      name="file"
                      v-on:change="onFileChange"
                      multiple="multiple"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="col-sm-4 col-sm-offset-2">
                <router-link class="btn btn-white" to="/file/list">
                  Anuluj
                </router-link>
                <button
                  v-if="canAddFile"
                  @click="create"
                  class="btn btn-primary"
                >
                  Dodaj
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import router from "../../router/router";
import { hasPermission } from "../../permissions";
import { filePermissionsConst } from "../../constants/fileConstants";

export default {
  name: "FileCreate",
  mixins: [],
  components: {},
  props: {},

  setup() {
    const fileObj = ref({
      name_pl: "",
      name_en: "",
      name_de: "",
      name_cpde: "",
      name_cpen: "",
      file: "",
    });
    const errorsAdminData = ref();
    const showErrors = ref(false);
    const store = useStore();
    const createFilesData = computed(() => store.getters.getCreateFilesData);

    const isPlOpen = ref(true);
    const isEnOpen = ref(true);
    const isDeOpen = ref(true);
    const isDeDeOpen = ref(true);
    const isDeEnOpen = ref(true);
    const isConfigOpen = ref(true);

    const chevronPlClass = computed(() =>
      isPlOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronEnClass = computed(() =>
      isEnOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeClass = computed(() =>
      isDeOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeDeClass = computed(() =>
      isDeDeOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeEnClass = computed(() =>
      isDeEnOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronConfigClass = computed(() =>
      isConfigOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const canAddFile = computed(() => hasPermission(filePermissionsConst.add));

    const create = () => {
      if (!canAddFile.value) {
        return;
      }

      showErrors.value = true;
      store.dispatch("createFile", fileObj.value);
    };

    const onFileChange = (e) => {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      fileObj.value.file = files[0];
    };

    watch(
      () => createFilesData.value,
      function (newValue) {
        if (newValue.status === 201) {
          router
            .push({
              name: "FilesList",
              path: "/file/list",
            })
            .then(() => {
              store.dispatch("showToaster", {
                type: "success",
                content: "Nowy plik został dodany",
              });
            });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    return {
      fileObj,
      errorsAdminData,
      showErrors,
      create,
      canAddFile,
      onFileChange,
      isPlOpen,
      isEnOpen,
      isDeOpen,
      isDeDeOpen,
      isDeEnOpen,
      isConfigOpen,
      chevronPlClass,
      chevronEnClass,
      chevronDeClass,
      chevronDeDeClass,
      chevronDeEnClass,
      chevronConfigClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
}
</style>
